<template>
  <div>
    <Table
      border
      :columns="item.columns"
      :data="item.tableData"
      v-for="(item, index) in tableList"
      :key="index"
    >
      <Address
        slot-scope="{ row, index }"
        :readonly="true"
        :value="row.address"
        slot="address"
      >
      </Address>
      <AddressList
        slot-scope="{ row, index }"
        :readonly="true"
         :noUpdate="true"
        :list="row.pickupAddress"
        slot="pickupAddress"
      >
      </AddressList>
      <AddressList
        slot-scope="{ row, index }"
        :readonly="true"
        :noUpdate="true"
        :list="row.receiveAddress"
        slot="receiveAddress"
      >
      </AddressList>
    </Table>
  </div>
</template>
<script>
export default {
  props: ["tableList"],
  data() {
    return {
      columns: [
        {
          title: "11111",
          key: "af",
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    var tt = this.tableList;
    for (let i = 0; i < tt.length; i++) {
      var m = tt[i].columns;
      for (let j = 0; j < m.length; j++) {
        if (m[j].key2) {
          m[j].key = m[j].key2;
        }
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/tableWrap.vue